module.exports = __webpack_public_path__ + "static/media/hausmart-logo-black.c2f4f378.png";